// Keep external exam sessions within the result list and exam details.
export default {
    computed: {
        isSsoExam() {
            return this.$store.getters["auth/isSsoLogin"] && ["TryExam", "MyExamResult"].includes(this.$route.name);
        }
    }
};
